import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResponseBody } from '@shared/model/response-body.models';
import { verificationCustomerModel } from '@shared/model/verification-customer.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VerificationCustomerService {
  private readonly baseUrl = environment.baseUrl;

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar
  ) {

  }

  getVerificationCustomerList(startPage: number, pageSize: number): Observable<verificationCustomerModel> {
    return this.http.get(`${this.baseUrl}/api/v1/admin/user/customer/verification?startPage=${startPage}&pageSize=${pageSize}`)
    .pipe(map((res: any) => res.data));
  }

  getVerificationCustomerById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/v1/admin/user/customer/verification/${id}`)
    .pipe(map((res: any) => res.data));
  }

  updateVerificationCustomer(id: number , data: any): Observable<ResponseBody> {
    return this.http.patch(`${this.baseUrl}/api/v1/admin/user/customer/verification/${id}`, data)
    .pipe(map((res: any) =>
    { 
      if(res.status === 200 || res.status === 201){
        this.snackBar.open(res.message , 'Undo', {
          duration: 1000
        })
      return  res.data
    }}
   ));

  }
}
